import React from 'react'

import { Skeleton } from '@/shared/components/atoms/Skeleton'
import { cn } from '@/shared/utils/helpers'

interface ScheduleSkeletonProps {
	count?: number
	className?: string
}

const ScheduleSkeleton: React.FC<ScheduleSkeletonProps> = ({
	count = 5,
	className = '',
}) => {
	return (
		<div
			className={cn(
				'flex gap-4 overflow-x-auto py-2',
				'[&::-webkit-scrollbar]:hidden [scrollbar-width:none] [-ms-overflow-style:none]',
				className
			)}
		>
			{Array.from({ length: count }).map((_, index) => (
				<div
					key={index}
					className="shrink-0 flex flex-col m-0 h-full bg-transparent overflow-hidden md:w-[200px] min-w-[165px] max-w-[200px]"
				>
					<div className="relative w-full aspect-square overflow-hidden md:rounded-1xl rounded-lg bg-[linear-gradient(141.39deg,var(--shade)_21.62%,var(--surface-light)_92.09%)] dark:bg-[linear-gradient(141.39deg,var(--background)_21.62%,var(--card)_92.09%)] border border-border/10 dark:border-border">
						{/* Header skeleton */}
						<div className="absolute top-0 left-0 right-0 z-10 flex items-center justify-between px-2 py-2 md:px-3 md:py-3">
							<div className="flex items-center gap-1">
								<Skeleton className="md:h-4 md:w-4 h-3 w-3 rounded-sm" />
								<Skeleton className="md:h-4 h-2 md:w-16 w-0 bg-zinc-300 dark:bg-zinc-700 md:block hidden" />
							</div>
							<div className="hidden md:flex items-center gap-1">
								<Skeleton className="md:h-8 md:w-8 h-6 w-6 rounded-full border border-action-item-border bg-black/50" />
								<Skeleton className="md:h-8 md:w-8 h-6 w-6 rounded-full border border-action-item-border bg-black/50" />
							</div>
						</div>
						{/* Thumbnails skeleton */}
						<div className="absolute inset-x-0 bottom-0 md:top-16 top-8 flex md:gap-3 gap-2 px-2 pb-2 md:px-3 md:pb-3">
							<Skeleton className="h-full aspect-square rounded-sm bg-zinc-300 dark:bg-zinc-700" />
							<Skeleton className="h-full aspect-square rounded-sm bg-zinc-300 dark:bg-zinc-700" />
						</div>
					</div>
					{/* Title skeleton */}
					<div className="pt-2 md:pt-4 pb-0 flex items-start min-h-[40px] px-1">
						<Skeleton className="md:h-4 h-3 w-[72%] bg-zinc-200 dark:bg-zinc-800" />
					</div>
				</div>
			))}
		</div>
	)
}

export default ScheduleSkeleton
